import { render } from "./EditRecipeButton.vue?vue&type=template&id=bab83e14"
import script from "./EditRecipeButton.vue?vue&type=script&lang=js"
export * from "./EditRecipeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__